// =============================================================================
// Copyright   : 2018 semantics GmbH
// Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
// Author      : Dirk Rothe, Tobias Schwarzkopf
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 156393 $
// Purpose     : notification reducers
// =============================================================================
// ---Third-party imports
import { handleActions } from 'redux-actions';
// ---Framework imports
import log from 'uix/logging';
// ---Local imports
import * as A from './actions';
// ---Globals
function filterNotifications(notifications, id) {
    return notifications.filter((notification)=>notification.id !== id);
}
// this also kills all old visibles from store
const MAX_NOTIFICATIONS = 10;
const handleShowNotification = (data, { payload })=>({
        ...data,
        notify: [
            payload,
            ...filterNotifications(data.notify, payload.id)
        ].slice(0, MAX_NOTIFICATIONS)
    });
export const data = [
    handleActions(new Map([
        [
            A.showNotification,
            handleShowNotification
        ],
        [
            A.successNotification,
            handleShowNotification
        ],
        [
            A.warningNotification,
            handleShowNotification
        ],
        [
            A.errorNotification,
            handleShowNotification
        ],
        [
            A.clearAllNotifications,
            (data, { payload })=>({
                    ...data,
                    notify: data.notify.map((n)=>({
                            ...n,
                            visible: false
                        }))
                })
        ],
        [
            A.dismissNotification,
            (data, { payload })=>({
                    ...data,
                    notify: data.notify.map((n)=>payload.id == n.id ? {
                            ...n,
                            visible: false
                        } : n)
                })
        ]
    ]), {
        notify: []
    })
];
